import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { Avatar, List, Space } from "antd";
import moment from "moment";
import { TimelinePostContainer } from "./component";
import { isEmpty } from "../../../lib/helpers/helpers";
import { TimelineCommentInput } from "../..";

const CommentList = ({ comments }) => (
	<List
		dataSource={comments}
		itemLayout="horizontal"
		renderItem={(props) => <Comments {...props} />}
	/>
);

const Comments = ({ comments, avatar, author, datetime, content }) => (
	<Space direction="horizontail" size="small" tw="w-full mt-4">
		<Avatar src={avatar} size="large" />
		<div
			tw="w-full h-auto flex flex-col gap-2 p-2 rounded-lg"
			style={{
				backgroundColor: "#F5F5F5",
				width: "100%",
				minWidth: "245px",
			}}>
			<div tw="flex flex-row flex-nowrap items-center gap-4">
				<h4 tw="m-0!" style={{ color: "#323232" }}>
					{author}
				</h4>
				<span tw="h-1 w-1 rounded-full bg-gray-400"></span>
				<h4 tw="m-0! text-xs!" style={{ color: "#999999" }}>
					{datetime}
				</h4>
			</div>
			<p tw="m-0! opacity-80">{content}</p>
		</div>
	</Space>
);

const TimelineCommentDetails = ({ timeline, focus, refetch }) => {
	const [comments, setComments] = useState([]);

	useEffect(() => {
		if (isEmpty(timeline)) {
			return;
		}

		const fetchedComment = timeline?.post_comments?.map((tl) => {
			return {
				author: `${tl.user.firstname} ${tl.user.lastname}`,
				avatar:
					tl.user.profile_pic_url ||
					"https://joeschmoe.io/api/v1/random",
				content: <span>{tl.comment_text}</span>,
				datetime: moment(tl?.createdAt).fromNow(),
			};
		});
		setComments(fetchedComment);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [timeline]);

	return (
		<TimelinePostContainer>
			{!isEmpty(timeline?.post_comments) && (
				<CommentList comments={comments} />
			)}
			<TimelineCommentInput
				focus={focus}
				timeline={timeline}
				refetch={refetch}
			/>
		</TimelinePostContainer>
	);
};

export default TimelineCommentDetails;
